module.exports = __webpack_public_path__ + "static/media/fashion-women-1.35d9d3fd.jpg";